// extracted by mini-css-extract-plugin
export default {"btn":"readMoreBtn_btn__tI48S","text":"readMoreBtn_text__NgshS","arrow":"readMoreBtn_arrow__0lQRY"};